import LanguagesListPageReducer from './LanguagesListPageReducer';

export default from './LanguagesListPageContainer';
export const LanguagesListPageReducers = {
  LanguagesListPageReducer,
};
